<template>
    <div @mouseover="isHovered = true"
         @mouseleave="isHovered = false"
         class="row flex-nowrap px-1 m-0">
        <div class="col-11 align-self-center p-1">
            <AppUserAvatar
                :user="user"
                withRightCaption
                class="overflow-ellipsis"
                :class="{ 'text-bold': selected }"/>
        </div>
        <div class="col-1 pl-1 align-self-center pl-0">
            <div v-show="selected && (!isHovered || disabled)"
                 class="text-muted" style="width: 16px">
                <i class="fal fa-sm fa-check"></i>
            </div>
            <div v-show="selected && isHovered && !disabled"
                 class="text-danger" style="width: 16px">
                <i class="fal fa-sm fa-times"></i>
            </div>
        </div>
    </div>
</template>

<script>
import AppUserAvatar from '../../../setters/AppUserAvatar'

export default {
    name: 'AppSelectUserRow',
    components: {AppUserAvatar},
    props: {
        user: {
            type: Object,
            required: true
        },
        selected: {
            type: Boolean,
            required: true
        },
        disabled: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            isHovered: false
        }
    }
}
</script>
